<template>
    <div>
        <div class="display-address-container">
            <slot>
                <h4>Lieferaddresse</h4>
            </slot>

            <div class="table-responsive">
                <table class="table table-borderless">
                    <tr v-if="address.contact_person">{{address.contact_person}}</tr>
                    <tr v-else>{{consumer.first_name}} {{ consumer.last_name }}</tr>
                    <tr v-if="address.company">
                        {{ address.company ? address.company :
                        subscription.details.consumer.company }}
                    </tr>
                    <tr>{{address.street}} {{address.house_number}}</tr>
                    <tr>{{address.postal_code}} {{address.city}} </tr>
                    <tr>{{$t('vue.manufaktur.amag.pickupAddressAmag.' + addressCountry)}}</tr>
                </table>
            </div>
        </div>

        <div class="change-address-modal">
            <div class="modal fade" :id="'formModal-' + identifier" tabindex="-1" role="dialog"
                 :aria-labelledby="'#formModal-' + identifier + 'Label'" aria-hidden="true">
                <div class="modal-dialog modal-lg" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" :id="'formModal-' + identifier + 'Label'">{{ addressType ===
                                'delivery' ? 'Liefer' : 'Rechnungs' }}adresse bearbeiten</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="form-row">
                                <div class="col-12 col-sm-10 col-lg-8 form-group">
                                    <label for="fields_contact_person">Name</label>
                                    <input required type="text" name="contact_person"
                                           id="fields_contact_person"
                                           dusk="contact_person"
                                           class="form-control"
                                           :class="getValidationClass(fields.contact_person.valid)"
                                           placeholder="Ansprechpartner"
                                           @change="validateContactPerson"
                                           v-model="fields.contact_person.value">
                                    <div class="invalid-feedback">
                                        @{{ fields.contact_person.error }}
                                    </div>
                                </div>
                                <div class="col-11 col-sm-10 col-lg-4 form-group">
                                    <label for="fields_company">
                                        Firmenname
                                        <small>(optional)</small>
                                    </label>
                                    <input type="text" name="company"
                                           id="fields_company"
                                           dusk="company"
                                           placeholder="Firma"
                                           @change="validateCompany"
                                           class="form-control"
                                           :class="getValidationClass(fields.company.valid)"
                                           v-model="fields.company.value">
                                    <div class="invalid-feedback">
                                        @{{ fields.company.error }}
                                    </div>
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="col-12 col-sm-12 col-lg-7 form-group mb-0">
                                    <label for="fields_street">Strasse und Hausnummer</label>
                                    <input required type="text"
                                           dusk="street"
                                           id="fields_street"
                                           class="form-control"
                                           name="street"
                                           :class="getValidationClass(fields.street.valid)"
                                           placeholder="Strasse + Hausnummer"
                                           @change="validateStreet"
                                           v-model="fields.street.value">
                                    <div class="invalid-feedback">
                                        @{{ fields.street.error }}
                                    </div>
                                </div>
                            </div>

                            <div class="form-row mt-2">
                                <div class="col-5 col-sm-4 col-lg-2 form-group">
                                    <label for="fields_postal_code">Postleitzahl</label>
                                    <input required type="text" name="postal_code"
                                           dusk="plz"
                                           id="fields_postal_code"
                                           class="form-control"
                                           :class="getValidationClass(fields.postal_code.valid)"
                                           placeholder="PLZ"
                                           @change="validatePostalCode"
                                           v-model="fields.postal_code.value">
                                    <div class="invalid-feedback">
                                        @{{ fields.postal_code.error }}
                                    </div>
                                </div>
                                <div class="col-7 col-sm-8 col-lg-5 form-group">
                                    <label for="fields_city">Ort</label>
                                    <input required type="text" name="city" id="fields_city"
                                           dusk="city"
                                           class="form-control"
                                           :class="getValidationClass(fields.city.valid)"
                                           placeholder="Ort / Stadt"
                                           @change="validateCity"
                                           v-model="fields.city.value">
                                    <div class="invalid-feedback">
                                        @{{ fields.city.error }}
                                    </div>
                                </div>
                            </div>

                            <div class="form-row mt-2">
                                <div class="col-11 col-sm-6 col-lg-4 form-group">
                                  <input type="hidden" name="country" v-model="fields.country.value" class="form-control">
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">Abbrechen</button>
                            <button type="button" class="btn btn-primary" @click="submit">Änderungen übernehmen</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PNotify from 'pnotify/dist/es/PNotify';

PNotify.defaults.styling = 'bootstrap4';
PNotify.defaults.icons = 'fontawesome5';

    export default {
        name: "UpdateAddress",
        props: {
          country: {
            type: String,
            default: "Deutschland"
          },
            consumer: {
                type: Object,
                required: true
            },
            subscription: {
                type: Object,
                required: true
            },
            vehicle: {
                type: Object,
                required: true
            },
            address: {
                type: Object,
                required: true
            },
            identifier: {
                type: String,
                required: false,
                default() {
                    return Math.random().toString(36).substring(7);
                }
            },
            addressType: {
                type: String,
                required: true,
                validator(value) {
                    return ['delivery', 'invoice'].indexOf(value) !== -1;
                }
            },
            csrfToken: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                fields: {
                    contact_person: {
                        value: "",
                        valid: 0,
                        error: "Bitte richtig ausfüllen",
                        success: ""
                    },
                    company: {
                        value: "",
                        valid: 0,
                        error: "",
                        success: ""
                    },
                    street: {
                        value: "",
                        valid: 0,
                        error: "",
                        success: ""
                    },
                    postal_code: {
                        value: "",
                        valid: 0,
                        error: "",
                        success: ""
                    },
                    city: {
                        value: "",
                        valid: 0,
                        error: "",
                        success: ""
                    },
                    country: {
                        value: "DE",
                        valid: 0,
                        error: "",
                        success: ""
                    },
                },
            };
        },
        computed: {
          addressCountry() {
            switch(this.address.country) {
              case "DE":
                return "germany"
              case "CH":
                return "switzerland"
              case "AT":
                return "austria"
            }
          },
            formValid() {
                let total = 0;
                this.fields.name.valid === 1 ? total += 1 : total += 0;
                this.fields.street.valid === 1 ? total += 1 : total += 0;
                this.fields.postal_code.valid === 1 ? total += 1 : total += 0;
                this.fields.city.valid === 1 ? total += 1 : total += 0;

                return total === 4;
            },
            formValues() {
                return {
                    contact_person: this.fields.contact_person.value,
                    company: this.fields.company.value,
                    street: this.fields.street.value,
                    city: this.fields.city.value,
                    postal_code: this.fields.postal_code.value,
                    country: this.fields.country.value,
                };
            }
        },
        methods: {
            submit() {
                let self = this;
                axios.patch('/api/checkout/' + this.subscription.id + '/update-addresses', {
                    identifier: this.subscription.identifier,
                    address_data: this.formValues,
                    addressType: this.addressType,
                    subscription: this.subscription.id,
                    consumer: this.consumer.id
                }).then(r => {
                    if (r.status === 202) {
                        PNotify.info(r.data.message);
                    } else {
                        PNotify.success(r.data.message);
                    }
                    this.$emit('address-updated');
                    self.closeModal();
                }).catch(e => {
                    PNotify.error(e.data.message);
                })
            },
            validateContactPerson() {
                let contact_person = this.fields.contact_person.value;
                if (contact_person.length > 0) {
                    let re = /^[A-Za-z\u00C0-\u017F\s\-\.]+$/;
                    let valid = re.test(contact_person);
                    this.fields.contact_person.valid = valid ? 1 : -1;
                } else {
                    this.fields.contact_person.valid = 0;
                }
            },
            validateCompany() {
                let company = this.fields.company.value;
                if (company != null) {
                    if (company.length > 0) {
                        this.fields.company.valid = 1;
                        return;
                    }
                }
                this.fields.company.valid = 0;
            },
            validateStreet() {
                let street = this.fields.street.value;
                if (street.length > 0) {
                    let re = /^\d+$/;
                    let invalid = re.test(street); // Contains numbers only
                    this.fields.street.valid = invalid ? -1 : 1;
                } else {
                    this.fields.street.valid = 0;
                }
            },
            validatePostalCode() {
                let plz = this.fields.postal_code.value;
                if (plz.length === 0) {
                    this.fields.postal_code.valid = 0;
                } else if (plz.length > 5) {
                    this.fields.postal_code.valid = -1;
                } else {
                    let re = /\b\d{4,5}(?:-\d{4})?\b/;
                    let valid = re.test(plz);
                    this.fields.postal_code.valid = valid ? 1 : -1;
                }
            },
            validateCity() {
                let city = this.fields.city.value;
                if (city.length > 0) {
                    let re = /^[A-Za-z\u00C0-\u017F ]+$/;
                    let valid = re.test(city);
                    this.fields.city.valid = valid ? 1 : -1;
                } else {
                    this.fields.city.valid = 0;
                }
            },
            getValidationClass(valid) {
                // valid could be -1,0,1
                let className = '';
                switch (valid) {
                    case -1:
                        className = 'is-invalid';
                        break;
                    case 1:
                        className = 'is-valid';
                        break;
                    default:
                        className = '';
                        break;
                }
                return className;
            },
            openModal: function () {
                $('#formModal-' + this.identifier).modal('show');
            },
            closeModal: function () {
                $('#formModal-' + this.identifier).modal('hide');
            },
        },
        mounted() {
            this.fields.contact_person.value = this.address.contact_person ?
                this.address.contact_person :
                this.consumer.first_name + " " + this.consumer.last_name;
            this.fields.company.value = this.address.company;
            this.fields.street.value = this.address.street;
            this.fields.postal_code.value = this.address.postal_code;
            this.fields.city.value = this.address.city;
            this.fields.country.value = this.address.country;

            this.validateContactPerson();
            this.validateCompany();
            this.validateStreet();
            this.validatePostalCode();
            this.validateCity();
        }
    }
</script>

<style scoped>

</style>
